import PDFViewer, { Props as PDFViewerProps } from 'components/media/PDFViewer'
import { useExplorerConfig } from '../providers'

export interface Props extends Omit<PDFViewerProps, 'file'> {
  mediaId: string
}

export default function MediaImage({ mediaId, ...rest }: Props) {
  const { templateDocs } = useExplorerConfig()
  const media = templateDocs?.media.find(m => m.id === mediaId)
  if (!media) return null

  return <PDFViewer file={media.url} scrollBarWidth={14} userSelect="none" {...rest} />
}
